module.exports = __webpack_public_path__ + "img/flags/HU.145d10a.png";